// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2SzoA","requiredAsterisk":"Info_requiredAsterisk__1sR-b"};